import ClientInviteModal from "./ClientInviteModal";

export default ClientInviteModal;
